import React, { useEffect, useState } from 'react';

// REDUX
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedWarehouse } from 'src/redux/warehouses/slice';
import { getAllWarehouses } from 'src/redux/warehouses/thunks';

const SelectWarehouse = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch<any>();
  const { warehouses, loading, selectedWarehouse } = useSelector(
    (state: any) => state.warehouses
  );

  const sortWarehouses = (items: any) =>
    items?.reduce((acc: any, warehouse: any) => {
      if (warehouse.name === 'TODOS') {
        return [warehouse, ...acc];
      }
      return [...acc, warehouse];
    }, []);

  const warehousesWithTodosFirst = sortWarehouses(warehouses?.warehouses);

  const handleClick = (warehouse: any) => {
    dispatch(setSelectedWarehouse(warehouse));
    setIsOpen(false);
  };

  const getInitData = async () => {
    const { payload } = await dispatch(
      getAllWarehouses({ filter: '', pagination: {} })
    );

    const storedWarehouse = localStorage.getItem('selectedWarehouse');
    if (storedWarehouse) {
      const parsedWarehouse = JSON.parse(storedWarehouse);
      dispatch(setSelectedWarehouse(parsedWarehouse));
      return;
    }
    dispatch(setSelectedWarehouse(sortWarehouses(payload.warehouses)[0]));
  };

  useEffect(() => {
    if (!selectedWarehouse.id) {
      getInitData();
    }
  }, []);

  return (
    <div className='relative mr-5'>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className='inline-flex items-center overflow-hidden rounded-lg border bg-white hover:bg-gray-50 hover:text-gray-700'
      >
        <span className='border-e px-4 pl-3 py-2 text-sm/none text-gray-600 hover:bg-gray-50 hover:text-gray-700'>
          {selectedWarehouse.name}
        </span>

        <div className='flex items-center p-1.5 justify-center h-full text-gray-600 hover:bg-gray-50 hover:text-gray-700'>
          <span className='sr-only'>Menu</span>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className={`h-5 w-5 transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`}
            viewBox='0 0 20 20'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
              clipRule='evenodd'
            />
          </svg>
        </div>
      </button>

      {isOpen && (
        <div
          className='absolute end-0 z-10 mt-2 w-56 divide-y divide-gray-100 rounded-md border border-gray-100 bg-white shadow-lg'
          role='menu'
        >
          <div className='p-2'>
            <strong className='block p-2 text-xs font-medium uppercase text-gray-400'>
              Seleccionar almacen
            </strong>

            {loading && (
              <div className='space-y-2'>
                <div className='block rounded-lg bg-gray-300 animate-pulse h-8 text-sm text-gray-500'></div>
                <div className='block rounded-lg bg-gray-300 animate-pulse h-8 text-sm text-gray-500'></div>
                <div className='block rounded-lg bg-gray-300 animate-pulse h-8 text-sm text-gray-500'></div>
              </div>
            )}

            {!loading && (
              <div className='space-y-2 max-h-56 overflow-auto'>
                {warehousesWithTodosFirst?.map((warehouse: any) => (
                  <button
                    onClick={() => handleClick(warehouse)}
                    key={warehouse.id}
                    className={`block w-full text-left rounded-lg px-4 py-2 text-sm text-gray-500 ${
                      selectedWarehouse.id === warehouse.id
                        ? 'bg-purple-600 text-white'
                        : 'hover:bg-gray-100 hover:text-gray-700'
                    }`}
                    role='menuitem'
                  >
                    {warehouse.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectWarehouse;
